const normalize = (value) =>
  (value ?? "")
    .toString()
    .trim()
    .toLowerCase();

const fuzzyMatch = (target, query) => {
  const normalizedQuery = normalize(query);

  if (!normalizedQuery) {
    return true;
  }

  const normalizedTarget = normalize(target);

  if (!normalizedTarget) {
    return false;
  }

  if (normalizedTarget.includes(normalizedQuery)) {
    return true;
  }

  let searchIndex = 0;

  for (const char of normalizedQuery) {
    searchIndex = normalizedTarget.indexOf(char, searchIndex);

    if (searchIndex === -1) {
      return false;
    }

    searchIndex += 1;
  }

  return true;
};

export default fuzzyMatch;
